module.exports = __webpack_public_path__ + "static/img/bg.514274b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/banner/bg.png
// module id = mY3f
// module chunks = 1